import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

interface VoirPlusButtonProps {
  isExpanded: boolean;
  setIsExpanded: (expanded: boolean) => void;
}

const VoirPlusButton: React.FC<VoirPlusButtonProps> = ({
  isExpanded,
  setIsExpanded,
}) => {
  const { t } = useTranslation();

  return (
    <Button
      type="link"
      size="small"
      className="p-0 h-auto text-bleu-hellio text-xs font-medium"
      onClick={() => setIsExpanded(!isExpanded)}
    >
      {isExpanded ? t('global:voir_moins') : t('global:voir_plus')}
    </Button>
  );
};

export default VoirPlusButton;
